import * as React from 'react';
import { createElement, useState, useRef, useMemo, useImperativeHandle } from 'react';
import { ProTable as OriginalProTable, } from '@ant-design/pro-components';
import { ConfigProvider, Tag } from 'antd';
import zhCNIntl from 'antd/es/locale/zh_CN';
import enUSIntl from 'antd/es/locale/en_US';
import { useOperationColumn } from './useOperationColumn';
import useRowSelection from './useRowSelection';
import { isPlainObj } from '../../shared/index';
const intlMap = {
    zhCNIntl,
    enUSIntl
};
const ProTable = (props, ref) => {
    const { search, columns, dynamicColumns, operationColumn, rowSelection, intl, pagination, toolbar, ...otherProps } = props;
    const formRef = useRef();
    const actionRef = useRef();
    const { config: rowSelectionConfig, getSelectedRows } = useRowSelection(rowSelection);
    const [activeMenuKey, setActiveMenuKey] = useState(() => {
        const [firstItem] = (toolbar?.menu?.items ?? []);
        return firstItem?.key;
    });
    const [collapsed, setCollapsed] = useState(false);
    const localOperationColumn = useOperationColumn(operationColumn);
    const formatedColumns = useMemo(() => {
        return columns?.map((item) => {
            const tempItem = { ...item };
            if (isPlainObj(tempItem.valueEnum) && tempItem.renderTag === true) {
                tempItem.render = (_, record) => {
                    const colValue = record[tempItem.dataIndex];
                    const target = tempItem.valueEnum[colValue];
                    return target?.text ? (createElement(Tag, { color: target?.status?.toLowerCase() }, target?.text)) : ('-');
                };
            }
            if (Array.isArray(tempItem.hideInSearch)) {
                tempItem.hideInSearch = !tempItem.hideInSearch.includes(activeMenuKey);
            }
            if (Array.isArray(tempItem.hideInTable)) {
                tempItem.hideInTable = !tempItem.hideInTable.includes(activeMenuKey);
            }
            return tempItem;
        });
    }, [columns, activeMenuKey]);
    const localColumns = useMemo(() => {
        const tempColumns = [...formatedColumns, ...(dynamicColumns ?? [])];
        return localOperationColumn ? [...tempColumns, localOperationColumn] : tempColumns;
    }, [localOperationColumn, formatedColumns, dynamicColumns]);
    const localPagination = useMemo(() => {
        if (pagination && typeof pagination?.current === 'number') {
            delete pagination.current;
        }
        if (pagination && typeof pagination?.total === 'number') {
            delete pagination.total;
        }
        return pagination;
    }, [pagination]);
    const localToolbar = useMemo(() => {
        let menu;
        if (toolbar.enableMenu === true && toolbar?.menu?.items?.length) {
            const menuItems = toolbar.menu.items.filter(item => !!item);
            menu = {
                ...(toolbar.menu ?? {}),
                activeKey: activeMenuKey,
                onChange: setActiveMenuKey,
                items: menuItems,
            };
        }
        return {
            ...toolbar,
            menu
        };
    }, [toolbar, activeMenuKey]);
    useImperativeHandle(ref, () => ({
        form: formRef.current,
        action: actionRef.current,
        getSelectedRows
    }));
    return (createElement(ConfigProvider, { locale: intlMap[intl || 'zhCNIntl'] },
        createElement(OriginalProTable, { ...otherProps, toolbar: localToolbar, rowSelection: rowSelectionConfig, pagination: localPagination, columns: localColumns, actionRef: actionRef, formRef: formRef, search: typeof search === 'boolean'
                ? search
                : {
                    ...search,
                    collapsed,
                    onCollapse: () => {
                        setCollapsed(!collapsed);
                        if (search.onCollapse) {
                            search.onCollapse(!collapsed);
                        }
                    }
                } })));
};
export default React.forwardRef(ProTable);
